var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 10,
    viewBox: "0 0 9 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M5.32453 4.99993L8.82895 8.50453C9.05702 8.73249 9.05702 9.10107 8.82895 9.32903C8.601 9.55699 8.23243 9.55699 8.00447 9.32903L4.49995 5.82443L0.995528 9.32903C0.767466 9.55699 0.399001 9.55699 0.171046 9.32903C-0.0570154 9.10107 -0.0570154 8.73249 0.171046 8.50453L3.67547 4.99993L0.171046 1.49533C-0.0570154 1.26737 -0.0570154 0.898796 0.171046 0.670836C0.28465 0.557123 0.434022 0.5 0.583287 0.5C0.732552 0.5 0.881817 0.557123 0.995528 0.670836L4.49995 4.17544L8.00447 0.670836C8.11818 0.557123 8.26745 0.5 8.41671 0.5C8.56598 0.5 8.71524 0.557123 8.82895 0.670836C9.05702 0.898796 9.05702 1.26737 8.82895 1.49533L5.32453 4.99993Z",
    fill: "#E74444"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXIcon);
export default __webpack_public_path__ + "static/media/xIcon.d0d78d0537dfc225c39b32e1e7598aaf.svg";
export { ForwardRef as ReactComponent };